export const GET_ALL_SLOTS = 'GET_ALL_SLOTS'
export const GET_BOOSTING_HISTORY = 'GET_BOOSTING_HISTORY'